import { render, staticRenderFns } from "./rp-sidebar-users.vue?vue&type=template&id=5a432f9c"
import script from "./rp-sidebar-users.vue?vue&type=script&lang=js"
export * from "./rp-sidebar-users.vue?vue&type=script&lang=js"
import style0 from "./rp-sidebar-users.vue?vue&type=style&index=0&id=5a432f9c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports